import * as React from 'react';
import { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import module from '../css/moduleStyle.module.css';
import styles from '../css/trfSfty.module.css';
import { useDashboard } from 'pages/components/DashboardContext';
import useNavigation from 'pages/components/UseNavigation';
import { SwItsGetDangerVehicleProvider, SwItsDangerVehicleTotalInfo } from 'pages/components/dashboard/SwItsGetDangerVehicle';
import { SwItsGetRoadStatTotalProvider, SwItsGetRoadStatInfo, SwItsGetRoadStatLine } from 'pages/components/dashboard/SwItsGetRoadStat';
import { SwItsGetEvntDetailProvider, SwItsGetEvntDetailInfoList, SwItsGetEvntDetailSnap, SwItsGetEvntDetailChart, SwItsGetEvntDetailTotalCntInfo } from 'pages/components/dashboard/SwItsGetEvntDetail';
import { SwItsRoadDayDataTotalProvider, SwItsRoadDayDataTotalChart } from 'pages/components/dashboard/SwItsGetRoadDayData';
import {RoadSurfaceHistory} from 'pages/components/dashboard/SwItsGetRoadSurfaceHistory';
import TrafficTaasView from 'pages/components/dashboard/SwItsTrafficTassView'
import { useTranslation } from 'react-i18next';

export default function TrafficSafetyViewM() {
  const [showHistory, setShowHistory] = useState(false);

  const { mapMessages, clearLastMapMessage } = useDashboard();
  const { t, i18n } = useTranslation();
  const openSmartWindow = () => {
    const newWindow = window.open(
      'http://192.168.0.111:8080/smartDashboard2',
      'smartWindow',
      'width=2000,height=2000,toolbar=no,menubar=no,scrollbars=yes,resizable=yes'
    );
    if (newWindow) {
      setTimeout(() => {
        newWindow.moveTo(4000, 4000);
      }, 1000);
    }
  };
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === 'i18nextLng' && e.newValue && e.newValue !== i18n.language) {
        i18n.changeLanguage(e.newValue);
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, [i18n]);

  useNavigation(mapMessages);

  useEffect(() => {
    if (mapMessages.length > 0) {
      clearLastMapMessage();
    }
  }, [mapMessages]);

  return (
    <Box sx={{ height: '190%', width: '100%' }}>
      <SwItsGetEvntDetailProvider>
        <div className="container">
          <div className="contWrap L_lmr">
            <div className="L_3m L_tb" style={{ order: '0' }}>
              {/* 위험물 차량 운행 현황 */}
              <div className={`${module.gap40} inner L_d flx_col`}>
                <div className="titWrap flx a_center j_spc_btw">
                  <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-02)' }}>{t('HazardousMaterialsVehicleDistributionMap')}</h2>
                </div>
                <div className={`${styles.TSVCont} ${styles.dangVehConts_trfSfty} dangVehConts boxCont flx flx_col`}>
                  <TrafficTaasView />
                  <div style={{ fontSize: '50px' }}></div>
                </div>
              </div>

              {/* 노면검지 시스템 */}
              {/* <div className={`${module.gap40} inner L_d flx_col`}>
                <div className="titWrap flx a_center j_spc_btw">
                  <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{color:'var(--iv-05)'}}> {t('RoadSurfaceRiskAnalysis')}</h2>
                </div>
                <div className={`${styles.TSVCont}${styles.rdStusConts_trfSfty} rdStusConts flx flx_col`}>
                  <SwItsRoadDayDataTotalProvider>
                    <SwItsRoadDayDataTotalChart />
                  </SwItsRoadDayDataTotalProvider>
                </div>
              </div> */}
              <div className={`${module.gap40} inner L_d flx_col`}>
                <div className="titWrap flx a_center j_spc_btw">
                  <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-05)' }}>
                    {showHistory ? t('RoadHistoryInquiry') : t('RoadSurfaceRiskAnalysis')}
                  </h2>
                  <button className='srchBtn'  onClick={() => setShowHistory(!showHistory)}> 
                    {showHistory ? t('노면 위험상태 분석') : t('노면 이력 조회')}
                  </button>
                </div>

                <div className={`${styles.TSVCont} ${styles.rdStusConts_trfSfty} rdStusConts flx flx_col`}>
                  <SwItsRoadDayDataTotalProvider>
                    {showHistory ? (
                      <RoadSurfaceHistory />
                    ) : (
                      <SwItsRoadDayDataTotalChart />
                    )}
                  </SwItsRoadDayDataTotalProvider>

                </div>
              </div>
            </div>

            {/* 위험행동 분포지도 */}
            <div className="inner L_3m flx flx_col gap40" style={{ order: '2' }}>
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-04)' }}>{t('UnsafeBehaviorsDistributionMap')}</h2>
              </div>
              <div className={`${styles.boxContHtMap_trfSfty} boxCont`}>
                <img
                  src='/images/module/heatMap.gif'
                  alt="smtrCrsrd"
                  style={{ cursor: 'pointer' }}
                  onClick={openSmartWindow}
                />
              </div>
              <SwItsGetEvntDetailSnap />
            </div>

            {/* 교차로 위험행동 통계 */}
            <div className={`${module.gap20} flx flx_col inner L_3m`} style={{ order: '1' }}>
              <div className="titWrap flx a_center j_spc_btw">
                <h2 className={`boxTit${i18n.language === 'en' ? '_en' : ''}`} style={{ color: 'var(--iv-03)' }}>{t('IntersectionIncidentsUnsafeBehaviors')}</h2>
              </div>
              <div className={`${styles.TSVContBox} flx`}>
                <div className={`${styles.unxpConts_trfSfty} unxpConts flx flx_col`}>
                  <SwItsGetEvntDetailInfoList />
                </div>
              </div>
            </div>
          </div>
        </div>
      </SwItsGetEvntDetailProvider>
    </Box>
  );
}
